export const DEFAULT_THEME = {
  heading_font: "Nunito",
  body_font: "Nunito Sans",
  colors: {
    primary: "#1D6FF2",
    accent: "#00CFFF",
    bg_dark: "#0A1628",
    bg_light: "#FFFFFF",
    heading_text: "#FFFFFF",
    body_text: "#E2E8F0",
  },
};

export const HEADING_FONTS = ["Plus Jakarta Sans", "Sora", "Cabinet Grotesk", "Poppins", "Raleway", "Nunito"];
export const BODY_FONTS = ["Inter", "DM Sans", "Nunito", "Lato", "Nunito Sans"];

const FONT_WEIGHTS = {
  "Plus Jakarta Sans": "400;500;600;700;800",
  "Sora": "400;500;600;700;800",
  "Poppins": "400;500;600;700;800;900",
  "Raleway": "400;500;600;700;800;900",
  "Inter": "400;500;600;700;800;900",
  "DM Sans": "400;500;600;700;800;900",
  "Nunito": "400;600;700;800;900",
  "Nunito Sans": "400;600;700;800;900",
  "Lato": "400;700;900",
};

export const PRESETS = [
  { name: "Deep Navy and Cyan", colors: { ...DEFAULT_THEME.colors } },
  { name: "Royal Blue and White", colors: { primary: "#3B82F6", accent: "#60A5FA", bg_dark: "#172554", bg_light: "#F8FAFC", heading_text: "#FFFFFF", body_text: "#DBEAFE" } },
  { name: "Midnight and Gold", colors: { primary: "#D4AF37", accent: "#F5C542", bg_dark: "#0B0F1A", bg_light: "#FAF6EC", heading_text: "#F5C542", body_text: "#D9CBA3" } },
];

export function normalizeTheme(t) {
  return { ...DEFAULT_THEME, ...(t || {}), colors: { ...DEFAULT_THEME.colors, ...((t && t.colors) || {}) } };
}

function ensureLink(id, href) {
  let l = document.getElementById(id);
  if (!l) {
    l = document.createElement("link");
    l.id = id;
    l.rel = "stylesheet";
    document.head.appendChild(l);
  }
  if (l.href !== href) l.href = href;
}

export function applyTheme(theme) {
  const t = normalizeTheme(theme);
  const hf = t.heading_font;
  const bf = t.body_font;
  const c = t.colors;

  const fams = [...new Set([hf, bf])].filter((f) => f !== "Cabinet Grotesk");
  if (fams.length) {
    const q = fams.map((f) => `family=${f.replace(/ /g, "+")}:wght@${FONT_WEIGHTS[f] || "400;700"}`).join("&");
    ensureLink("td-font-link", `https://fonts.googleapis.com/css2?${q}&display=swap`);
  }
  if (hf === "Cabinet Grotesk" || bf === "Cabinet Grotesk") {
    ensureLink("td-fontshare-link", "https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@400,500,600,700,800,900&display=swap");
  }

  let st = document.getElementById("td-theme-style");
  if (!st) {
    st = document.createElement("style");
    st.id = "td-theme-style";
    document.head.appendChild(st);
  }
  st.textContent = `
    :root {
      --td-primary: ${c.primary};
      --td-accent: ${c.accent};
      --td-bg-dark: ${c.bg_dark};
      --td-bg-light: ${c.bg_light};
      --td-heading: ${c.heading_text};
      --td-body: ${c.body_text};
    }
    body { font-family: '${bf}', 'Nunito Sans', sans-serif !important; }
    .font-display, h1, h2, h3, h4 { font-family: '${hf}', 'Nunito', sans-serif !important; }
    .btn-primary, .btn-blue { background: var(--td-primary) !important; }
    .btn-primary:hover, .btn-blue:hover { background: var(--td-primary) !important; filter: brightness(1.12); }
    [class*="bg-[#1D6FF2]"] { background-color: var(--td-primary) !important; }
    [class*="text-[#00CFFF]"], [class*="text-[#00BFFF]"], .eyebrow-dark { color: var(--td-accent) !important; }
    [class*="bg-[#00CFFF]"] { background-color: var(--td-accent) !important; }
    body { background: var(--td-bg-dark); }
    .bg-dark-premium { background: var(--td-bg-dark) !important; }
    [class*="bg-[#0A1628]"], [class*="bg-[#04091A]"] { background-color: var(--td-bg-dark) !important; }
    [class*=" bg-white"]:not([class*="bg-white/"]), [class^="bg-white"]:not([class*="bg-white/"]) { background-color: var(--td-bg-light) !important; }
    h1[class*="text-white"], h2[class*="text-white"], h3[class*="text-white"], h4[class*="text-white"] { color: var(--td-heading) !important; }
    .td-calendar { font-family: '${bf}', 'Nunito Sans', sans-serif; }
  `;
}
